import type { FC, PropsWithChildren } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from './CarouselWrapper.module.scss';

export const CarouselWrapper: FC<PropsWithChildren> = ({ children }) => (
    <div className={styles.carouselSwiper}>{children}</div>
);
